export const environment = {
  production: false,
  apiUrl: '/api',
  s3Prefix: 'https://s3.ru1.storage.beget.cloud/b46325dbaad6-ilove/'
};
